import { IAddressInfoSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

/**
 * Возвращает текст выбранного города.
 */
export function getCity(address: IAddressInfoSchema[]): string {
  const location = address.find(({ type }) => type === 'location');

  return location !== undefined ? location.fullName : '';
}
